function requireAll(r) { r.keys().forEach(r); }

requireAll( require.context( './ico/', true ) );
requireAll( require.context( './svg/', true, /\.svg$/) );
requireAll( require.context( './fonts/', true ) );
requireAll( require.context( './videos/', true ) );
requireAll( require.context( './admin-thumbs/', true, /\.png$/) );

import $, { event } from 'jquery';

import { CountUp } from 'countup.js';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin( ScrollTrigger );

import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';

import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import fitty from 'fitty';

import tabsList from '../../../../../vendor/tabsspaces/tabslist/src/assets/tabsList.js';

import { NavDrag } from '../src/js/navdrag.js';
import { ToggleSection } from '../src/js/toggleSection.js';
import { Accordion } from '../src/js/accordion.js';
import { HideFilter } from '../src/js/hideFilter.js';


window.jQuery = $;
window.$ = $;

$(function () {

	var PROJECT = {

		common: {

			getViewport: function() {

				var viewPortWidth;
				var viewPortHeight;

				if (typeof window.innerWidth !== 'undefined') {

					viewPortWidth = window.innerWidth;
					viewPortHeight = window.innerHeight;

				} else if ( typeof document.documentElement !== 'undefined' &&
							typeof document.documentElement.clientWidth !== 'undefined' &&
							document.documentElement.clientWidth !== 0 ) {

					viewPortWidth = document.documentElement.clientWidth;
					viewPortHeight = document.documentElement.clientHeight;

				} else {

					viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
					viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
				}

				return { width : viewPortWidth , height : viewPortHeight };

			},

			init: function () {

				PROJECT.hero.init();

				PROJECT.nav.init();

				PROJECT.toggle.init();

				PROJECT.gform.init();

				PROJECT.list.init();

				PROJECT.header.init();

				PROJECT.sectionHeader.init();

				PROJECT.menu.init();

				PROJECT.anim.init();

				PROJECT.countDown.init();

				PROJECT.stackable.init();

				PROJECT.horizontalBlocks.init();

				PROJECT.carousels.init();

				PROJECT.svg.init();

				PROJECT.sectionParalax.init();

				PROJECT.simpleAnimations.init();

				PROJECT.mousefollow.init();

				PROJECT.backgroundParallax.init();

				PROJECT.videoEmbed.init();

				PROJECT.fitty.init();

				PROJECT.lightboxSpeaker.init();

				PROJECT.lightboxPartner.init();

				PROJECT.schedule.init();

				window.tabsList.init();

			},

		},

		loader: {

			show: function() {

				if ( $( '.jsGlobalLoader' ).length ) return;

				const $loader = $( '<div class="c-global-loader jsGlobalLoader"><div class="a-loader"></div></div>' );

				$( 'body' ).append( $loader );

			},

			hide: function() {

				$( '.jsGlobalLoader' ).remove();

			}

		},

		header: {

			init: function() {

				PROJECT.header.getHeight( '.jsSiteHeader', '--header-site-height' );

				window.onresize = function() {

					PROJECT.header.getHeight( '.jsSiteHeader', '--header-site-height' );

				}

			},

			getHeight: function( targetClass, cssVariable ) {

				var $this = $( targetClass );

				if ( $this.length > 0 ) {

					$( 'html' ).css( cssVariable, $this.height() );

				}

			},

		},

		sectionHeader: {

			section: '.jsSectionHeader',
			foreground: '.jsSectionHeaderForeground',
			text: '.jsSectionHeaderText',
			svgDesktop: '.jsSectionHeaderSvgDesktop',
			svgMobile: '.jsSectionHeaderSvgMobile',
			iconContainer: '.jsHeaderIconWrapper',

			scrollTrigger: null,

			init: function() {

				const section = document.querySelector(PROJECT.sectionHeader.section);

				if (!section) {
					return;
				}

				PROJECT.sectionHeader.animateIn();
				PROJECT.sectionHeader.setup();
				PROJECT.sectionHeader.scaleText();

			},

			animateIn: function() {

				const viewport = PROJECT.common.getViewport();

				const section = document.querySelector(PROJECT.sectionHeader.section);
				const svgs = viewport.width < 996 ? section.querySelectorAll(PROJECT.sectionHeader.svgMobile) : section.querySelectorAll(PROJECT.sectionHeader.svgDesktop);
				const iconContainer = section.querySelector(PROJECT.sectionHeader.iconContainer);

				if (!svgs.length) {
					return;
				}

				svgs.forEach(svg => {
					gsap.fromTo(svg,
						{
							scale: 1.2,
						},
						{
							scale: 1,
							duration: 1,
							ease: 'power3.out'
						}
					);
				});

				if (iconContainer) {

					gsap.fromTo(iconContainer,
						{
							scale: 0,
							opacity: 0
						},
						{
							scale: 1,
							opacity: 1,
							duration: 0.75,
							delay: 0.5,
							ease: 'back.out(1.7)'
						}
					);
				}

			},

			setup: function() {

				const section = document.querySelector(PROJECT.sectionHeader.section);
				const foreground = section.querySelector(PROJECT.sectionHeader.foreground);
				const iconContainer = section.querySelector(PROJECT.sectionHeader.iconContainer);

				if (!section || !foreground) {
					return;
				}

					const tl = gsap.timeline({
						scrollTrigger: {
							trigger: section,
							start: 'top top',
							end: () => '+=' + foreground.offsetHeight,
							pin: true,
							scrub: 1,
							anticipatePin: 1,
							invalidateOnRefresh: true
						}
					});

				tl.to(foreground, {
					y: -foreground.offsetHeight,
					ease: 'none'
				}, 0);

				if (iconContainer) {
					tl.to(iconContainer, {
						y: -foreground.offsetHeight * 1.5,
						ease: 'none'
					}, 0);
				}

			},

			scaleText: function() {

				const texts = document.querySelectorAll(PROJECT.sectionHeader.text);

				if (!texts.length) {
					return;
				}

				texts.forEach(text => {

					const updateFontSize = (isInitial = false) => {

						const currentSize = text.style.fontSize;
						text.style.fontSize = '';

						const bbox = text.getBBox();
						const viewport = PROJECT.common.getViewport();

						const paddingX = viewport.width < 996 ? 0.95 : 0.75;
						const paddingY = viewport.width < 996 ? 0.95 : 0.75;
						const maxWidth = viewport.width * paddingX;
						const maxHeight = viewport.height * paddingY;

						const scaleX = maxWidth / bbox.width;
						const scaleY = maxHeight / bbox.height;

						const scale = Math.min(scaleX, scaleY, 1);

						const computedStyle = window.getComputedStyle(text);
						const currentFontSize = parseFloat(computedStyle.fontSize);
						const newFontSize = currentFontSize * scale;

						const minSize = 80;
						const maxSize = 200;
						const finalSize = Math.max(minSize, Math.min(maxSize, newFontSize));

						text.style.fontSize = currentSize;

						gsap.to(text, {
							fontSize: finalSize + 'px',
							duration: isInitial ? 0 : 0.6,
							ease: 'power2.out'
						});
					};

					updateFontSize(true);

					let resizeTimer;
					window.addEventListener('resize', () => {
						clearTimeout(resizeTimer);
						resizeTimer = setTimeout(() => updateFontSize(false), 100);
					});

				});

			}

		},

		toggle: {

			/*
			 * Toggle Text in Button label
			 * Used in jsnNavToggle
			 */

			clickElm: '.jsToggleText',
			labelElm: '.jsToggleTextLabel',
			dataAttr: 'toggle-text',

			init: function() {

				$( document ).on( 'click', PROJECT.toggle.clickElm, PROJECT.toggle.switch );

			},

			switch: function( e ) {

				let $elm =  $( this );

				let $label = $elm.find( PROJECT.toggle.labelElm );

				let toggleText = $elm.data( PROJECT.toggle.dataAttr );

				let currentText = $label.text();

				let newText = currentText == toggleText.current ? toggleText.toggle : toggleText.current;

				$label.text( newText );

				$elm.attr( 'title', newText );

			}

		},

		nav: {

			/*
			 * Toggle Core Nav Visibility
			 * - Sets a css class on html elmement
			 * - Disable tabsindex when menu is closed
			 * - Click and Key controlled
			 */


			mainElm: '.navMain',
			clickElm: '.jsNavToggle',
			openClass: 'state-c-nav--nav-open',



			init: function() {

				$( document ).on( 'click', PROJECT.nav.clickElm, PROJECT.nav.toggle );

				$( document ).on( 'keyup', PROJECT.nav.esc );

				$( PROJECT.nav.mainElm + ' a' ).each( function() {

					$( this ).attr('tabindex', -1 );

				});

			},

			toggle: function() {

				if ( $( 'html' ).hasClass( PROJECT.nav.openClass ) ) {

					PROJECT.nav.close();

				} else {

					PROJECT.nav.open();
				}
			},

			esc: function( e ) {

				if ( e.keyCode === 27 ) {

					PROJECT.nav.close();

				}
			},

			open: function() {

				$( 'html' ).addClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm + ' a').each( function() {

					$( this ).removeAttr('tabindex', -1 );

				});

			},

			close: function() {

				$( 'html' ).removeClass( PROJECT.nav.openClass );

				$( PROJECT.nav.mainElm  + ' a' ).each( function() {

					$( this ).attr('tabindex', -1 );

				});

			}


		},

		menu: {

			init: function() {

				$( document ).off( 'click', '.v-nav--header .v-nav__item--has-children > a' );
				$( document ).on( 'click', '.v-nav--header .v-nav__item--has-children > a', {

					class: 'v-nav__item--open',
					classElement: '.v-nav__item',
					toggleElement: '.sub-menu',
					menuMenu: '.c-header__wrapper-nav',

				}, PROJECT.menu.toggle );

			},

			toggle: function( e ) {

				e.preventDefault();

				var parent = $( this ).closest( e.data.classElement );

				var parentMenuWrapper = $( this ).closest( e.data.menuMenu );

				if (getComputedStyle(parentMenuWrapper[0]).position === 'fixed') {

					if ( !$( parent ).hasClass( e.data.class ) ) {

						$( parent ).addClass( e.data.class );

						if ( e.data.toggleElement !== '' ) {

							$(parent).find(e.data.toggleElement).stop(true, true).slideDown(350);

						}

					} else {

						$( parent ).removeClass( e.data.class );

						if ( e.data.toggleElement !== '' ) {

							if ( e.data.toggleElement !== '' ) {
								$(parent).find(e.data.toggleElement).stop(true, true).slideUp(350, function() {
									$(this).css('display', '');
								});
							}

						}

					}

				}

			},

		},

		horizontalBlocks: {

			card: '.jsSectionHorizontalBlocksCard',
			cards: '.jsSectionHorizontalBlocksCards',
			section: '.jsSectionHorizontalBlocks',
			wrapper: '.jsSectionHorizontalBlocksWrapper',
			scrollTriggers: [],
			breakpoint: 996,

			init: function() {

				PROJECT.horizontalBlocks.setup();
				PROJECT.horizontalBlocks.handleResize();

			},

			setup: function() {

				const sections = document.querySelectorAll(PROJECT.horizontalBlocks.section);

				if (!sections.length) {
					return;
				}

				const viewportWidth = PROJECT.common.getViewport().width;

				if (viewportWidth >= PROJECT.horizontalBlocks.breakpoint) {
					PROJECT.horizontalBlocks.createScrollAnimation();
				} else {
					PROJECT.horizontalBlocks.killScrollAnimation();
				}

			},

			createScrollAnimation: function() {

				const sections = document.querySelectorAll(PROJECT.horizontalBlocks.section);

				if (!sections.length) {
					return;
				}

				if (PROJECT.horizontalBlocks.scrollTriggers.length) {
					return;
				}

				sections.forEach(function(section) {

					const cardsWrapper = section.querySelector(PROJECT.horizontalBlocks.wrapper);
					const cardsContainer = section.querySelector(PROJECT.horizontalBlocks.cards);

					if (!cardsContainer) {
						return;
					}

					const cards = gsap.utils.toArray(
						section.querySelectorAll(PROJECT.horizontalBlocks.card)
					);

					if (!cards.length) {
						return;
					}

					const scrollDistance = cardsContainer.scrollWidth - cardsContainer.offsetWidth;


					const tlDwell = 1;
					const tlScroll = 2;
					const tlTotal = tlDwell * 2 + tlScroll;
					const totalPinDistance = scrollDistance * (tlTotal / tlScroll);

					gsap.set(cards, { x: 0 });

					const tl = gsap.timeline({
						scrollTrigger: {
							trigger: cardsWrapper,
							pin: true,
							scrub: 1,
							start: "top top",
							end: () => "+=" + totalPinDistance,
							anticipatePin: 1,
							invalidateOnRefresh: true
						}
					});

					tl.to(cardsWrapper, {opacity: 1, duration: tlDwell, ease: "none"})
					.to(cards, { x: -scrollDistance, duration: tlScroll, ease: "none" })
					.to(cardsWrapper, {opacity: 1, duration: tlDwell, ease: "none"});

					PROJECT.horizontalBlocks.scrollTriggers.push(tl);

				});

			},

			killScrollAnimation: function() {

				if (PROJECT.horizontalBlocks.scrollTriggers.length) {

					PROJECT.horizontalBlocks.scrollTriggers.forEach(function(tween) {
						var st = tween.scrollTrigger;
						if (st) {
							var triggerEl = st.trigger;
							st.kill();
							if (triggerEl) {
								gsap.set(triggerEl, { clearProps: "all" });
							}
						}
						tween.kill();
					});

					PROJECT.horizontalBlocks.scrollTriggers = [];

					gsap.set(PROJECT.horizontalBlocks.card, { clearProps: "all" });

					ScrollTrigger.refresh();
				}

			},

			handleResize: function() {

				let resizeTimer;

				window.addEventListener('resize', function() {

					clearTimeout(resizeTimer);

					resizeTimer = setTimeout(function() {

						PROJECT.horizontalBlocks.killScrollAnimation();
						PROJECT.horizontalBlocks.setup();
						ScrollTrigger.refresh();

					}, 250);

				});

			}

		},

		sectionParalax: {

			section: '.jsSectionParalax',
			imageTop: '.jsParalaxImageTop',
			imageBottom: '.jsParalaxImageBottom',
			titleWrapper: '.jsParalaxTitleWrapper',
			paralaxTimelines: [],

			init: function() {

				PROJECT.sectionParalax.setup();
				PROJECT.sectionParalax.handleResize();

			},

			setup: function() {

				PROJECT.sectionParalax.killParalaxScroll();

				const sections = document.querySelectorAll(PROJECT.sectionParalax.section);
				if (!sections.length) {
					return;
				}

				const viewportWidth = PROJECT.common.getViewport().width;
				const desktopBreakpoint = 768;

				if (viewportWidth < desktopBreakpoint) {
					return;
				}

				sections.forEach(function(section) {

					const imageTop = section.querySelectorAll(PROJECT.sectionParalax.imageTop);
					const imageBottom = section.querySelectorAll(PROJECT.sectionParalax.imageBottom);
					const titleWrapper = section.querySelectorAll(PROJECT.sectionParalax.titleWrapper);

					if (imageTop.length || imageBottom.length || title.length) {

						const tl = gsap.timeline({
							scrollTrigger: {
								trigger: PROJECT.sectionParalax.section,
								start: 'top 95%',
								end: 'bottom 5%',
								scrub: 0.6,
							},
							defaults: {
								ease: 'power1.out'
							}
						});

						if (imageTop.length) {
							tl.fromTo(imageTop, {
								y: '20px',
							}, {
								y: '-75px',
							}, 0.1);
						}

						if (imageBottom.length) {
							tl.fromTo(imageBottom, {
								y: '85px',
							}, {
								y: '-30px',
							}, 0.3);
						}

						if (titleWrapper.length) {
							// Text layer sits above the images, so move it more.
							// Negative Y makes it travel upward (same general direction as images).
							tl.fromTo(titleWrapper, {
								y: 0,
							}, {
								y: -120,
							}, 0.1);
						}

						PROJECT.sectionParalax.paralaxTimelines.push(tl);
					}
				});
			},

			killParalaxScroll: function() {

				if (!PROJECT.sectionParalax.paralaxTimelines.length) {
					return;
				}

				PROJECT.sectionParalax.paralaxTimelines.forEach(function(tl) {
					if (tl.scrollTrigger) {
						tl.scrollTrigger.kill();
					}
					tl.kill();
				});

				gsap.set(
					[
						PROJECT.sectionParalax.imageTop,
						PROJECT.sectionParalax.imageBottom,
						PROJECT.sectionParalax.title,
						PROJECT.sectionParalax.titleWrapper
					],
					{ clearProps: "all" }
				);

				PROJECT.sectionParalax.paralaxTimelines = [];

			},

			handleResize: function() {

				let resizeTimer;

				window.addEventListener('resize', function() {
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(function() {
						PROJECT.sectionParalax.killParalaxScroll();
						PROJECT.sectionParalax.setup();
					}, 250);
				});
			}
		},

		simpleAnimations: {

			init: function() {

				PROJECT.simpleAnimations.sectionFadeInUp();
				PROJECT.simpleAnimations.sectionItemsFadeInUp();
				PROJECT.simpleAnimations.countDownFadeUp();
				PROJECT.simpleAnimations.numbersFadeUp();
				PROJECT.simpleAnimations.postHeader();

			},

			sectionFadeInUp: function() {
				const animateElms = document.querySelectorAll( '.jsSectionFadeUp' );
				PROJECT.simpleAnimations.animate(
					animateElms,
					0.1,
					'0px 0px -10% 0px',
				);
			},

			sectionItemsFadeInUp: function() {
				const sections = document.querySelectorAll('.jsSectionItemsFadeUpContainer');

				if (!sections.length) {
					return;
				}

				sections.forEach(function(section) {

					const animateElms = section.querySelectorAll( '.jsSectionItemsFadeUp' );

					PROJECT.simpleAnimations.animate(
						animateElms,
						0.1,
						'0px 0px -10% 0px',
					);
				});
			},


			countDownFadeUp: function() {
				const animateElms = document.querySelectorAll( '.jsFadeUpCount' );
				PROJECT.simpleAnimations.animate(
					animateElms,
					0.3,
				);
			},

			numbersFadeUp: function() {
				const animateElms = document.querySelectorAll( '.jsFadeUpNumbers' );
				PROJECT.simpleAnimations.animate(
					animateElms,
					0.1,
				);
			},

			postHeader: function() {
				const animateElms = document.querySelectorAll( '.jsFadeUpPostHeader' );
				PROJECT.simpleAnimations.animate(
					animateElms,
					0,
					'0px 0px 100px 0px',
				);
			},

			animate: function( elems, threshold,rootMargin ) {
				if ( typeof elems === 'object' && elems.length > 0 ) {
					if ( !threshold ) {
						threshold = 0.1;
					}

					if ( !rootMargin ) {
						rootMargin: '0px 0px 0% 0px';
					}

					// Group elements by their top position
					var positionGroups = {};

					for ( var i = 0; i < elems.length; i++ ) {
						var rect = elems[ i ].getBoundingClientRect();
						var topPos = Math.round( rect.top + window.scrollY );

						if ( !positionGroups[ topPos ] ) {
							positionGroups[ topPos ] = [];
						}
						positionGroups[ topPos ].push( elems[ i ] );
					}

					// Assign delay index to elements sharing the same position
					for ( var pos in positionGroups ) {
						if ( positionGroups.hasOwnProperty( pos ) ) {
							var group = positionGroups[ pos ];

							for ( var g = 0; g < group.length; g++ ) {
								group[ g ].setAttribute( 'data-anim-delay-index', g );
							}
						}
					}

					// Define observer instance
					var observer = new IntersectionObserver( onIntersection, {
						root: null,
						rootMargin: rootMargin,
						threshold: threshold,
					} );

					// Callback is called on intersection change
					function onIntersection( entries ) {
						for ( var j = 0; j < entries.length; j++ ) {
							var entry = entries[ j ];

							if ( entry.isIntersecting ) {
								var thisElm = entry.target;
								var delayIndex = parseInt( thisElm.getAttribute( 'data-anim-delay-index' ) || 0, 10 );
								var delayMs = delayIndex * 150; // 150ms stagger per sibling

								thisElm.style.transitionDelay = delayMs + 'ms';
								thisElm.classList.add( 'animDone' );

								observer.unobserve( thisElm );
							}
						}
					}

					for ( var i = 0; i < elems.length; i++ ) {
						observer.observe( elems[ i ] );
					}
				}
			},

		},

		gform: {

			init: function() {

				$( document ).on( 'gform_post_render', PROJECT.gform.hideLoader );

				$( document ).on( 'click.loader', '.gform_button', PROJECT.gform.showLoader );
				$( document ).on( 'click.loader', '.gform_next_button, gform_previous_button', PROJECT.gform.showLoader );
				$( document ).on( 'submit', '.gform_wrapper form', PROJECT.gform.showLoader );

				$( document ).on( 'gform_page_loaded', PROJECT.gform.hideLoader );

				$( document ).on( 'gform_confirmation_loaded', PROJECT.gform.showConfirmation );
				$( document ).on( 'click.loader', '.gformCloseConfirmation', PROJECT.gform.hideConfirmation );


				$( document ).on( 'focus', 'input, textarea, select', function() {
					$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
				});

				$( document ).on( 'blur', 'input, textarea, select', function( e ) {
					if( !$(this).val() ) {
						$( this ).parents( '.gfield' ).removeClass( 'state--has-focus' );
					}
				});

				PROJECT.gform.fixHasFocus();

			},

			fixHasFocus: function() {

				$( 'input, textarea, select' ).each(function() {

					if( $(this).val() ) {
						$( this ).parents( '.gfield' ).addClass( 'state--has-focus' );
					}

				});

			},

			showLoader: function() {

				var $gformContainer = $(this).closest( '.gformContainer' );
				var $gformLoader = $gformContainer.find( '.gformLoader' );

				$gformLoader.fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideLoader: function() {

				$( '.gformLoader' ).fadeOut( 300 );

			},

			showConfirmation: function() {

				$( '.gformConfirmation' ).fadeIn( 300 ).css( 'display', 'flex' );

			},

			hideConfirmation: function() {

				$( '.gformConfirmation' ).fadeOut( 300 );

			}

		},

		list: {

			// Only for project based code.
			init:function() {

				window.tabsList.options.callbacks.afterAjaxCallback = function( data ) {

					PROJECT.simpleAnimations.sectionItemsFadeInUp();

				};
			}

		},

		anim: {

			init: function() {

				PROJECT.anim.countUp();

			},

			countUp: function() {
				const $numbers = $('.jsCountUpNum');

				if ($numbers.length > 0) {
					$numbers.each(function() {
						var counter = $(this).attr('data-countup-num');
						var type = $(this).attr('data-countup-type');

						var decimalTotal = 0;
						if (counter.indexOf('.') > -1) {
							decimalTotal = counter.split('.')[1].length;
						}

						let decimal = ',';

						if( type === ',') {

							decimal = '.'

						}

						const countUp = new CountUp(this, counter, {
							separator: type,
							decimal: decimal,
							decimalPlaces: decimalTotal,
							enableScrollSpy: true,
							scrollSpyOnce: true,
						});
					});
				}
			},

		},

		countDown: {

			init: function() {

				document.querySelectorAll(".jsCountDown").forEach(PROJECT.countDown.handler);

			},

			handler: function( container ) {

				const deadline = parseInt(container.dataset.countdownDeadline, 10);
				const pad      = n => String(n).padStart(2, '0');

				const dayEl    = container.querySelector(".jsCountDownDays");
				const hourEl   = container.querySelector(".jsCountDownHours");
				const minuteEl = container.querySelector(".jsCountDownMinutes");
				const secondEl = container.querySelector(".jsCountDownSeconds");

				const x = setInterval(function () {
					const t = deadline - Date.now();

					if (t < 0) {
						clearInterval(x);
						dayEl.innerHTML = hourEl.innerHTML = minuteEl.innerHTML = secondEl.innerHTML = "00";
						return;
					}

					dayEl.innerHTML    = pad(Math.floor(t / (1000 * 60 * 60 * 24)));
					hourEl.innerHTML   = pad(Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
					minuteEl.innerHTML = pad(Math.floor((t % (1000 * 60 * 60)) / (1000 * 60)));
					secondEl.innerHTML = pad(Math.floor((t % (1000 * 60)) / 1000));
				}, 1000);

			}

		},

		fitty: {

			refitTimeout: null,

			init: function() {

				PROJECT.fitty.bind();
				PROJECT.fitty.waitForFonts();

			},

			bind: function(selector = '.jsFitty', options = {}) {

				const elements = document.querySelectorAll(selector);
				if (!elements.length) return [];

				return fitty(selector, {
					minSize: 12,
					maxSize: 512,
					multiLine: false,
					observeMutations: false,
					...options
				});

			},

			waitForFonts: function() {

				if (document.fonts && document.fonts.ready) {
					document.fonts.ready.then(function() {
						setTimeout(PROJECT.fitty.setFitty, 150);
					});
					return;
				}

				PROJECT.fitty.runFitty();

			},

			runFitty: function() {

				if (PROJECT.fitty.refitTimeout) {
					clearTimeout(PROJECT.fitty.refitTimeout);
				}

				PROJECT.fitty.refitTimeout = setTimeout(PROJECT.fitty.setFitty, 1000);

			},

			setFitty: function() {

				fitty.fitAll();

			}

		},

		svg: {

			init: function() {

				PROJECT.svg.numbers();
				PROJECT.svg.cta();
				PROJECT.svg.postHeader();
				PROJECT.svg.editorMedia();
				PROJECT.svg.speakers();
				PROJECT.svg.partners();
				PROJECT.svg.schedule();
				PROJECT.svg.listHeader();
				PROJECT.svg.liveCarousel();

			},

			numbers: function() {

				const numbers = document.querySelectorAll('.jsNumbersSvg');

				numbers.forEach(elm => {

					PROJECT.svg.animateSVGDrawOnScrollGsap(elm);

				});

			},

			cta: function() {

				const ctas = document.querySelectorAll('.jsCtaSvg');

				ctas.forEach(elm => {

					PROJECT.svg.animateSVGOnScrollGsap(elm, {
						duration: 0,
						staggerEach: 0.0025
					});

				});

			},

			postHeader: function() {

				const postHeaders = document.querySelectorAll('.jsPostHeaderSvg');

				postHeaders.forEach(elm => {

					PROJECT.svg.animateSVGOnScrollGsap(elm);

				});

			},

			editorMedia: function() {

				const svgs = document.querySelectorAll('.jsEditorMediaSvg');

				svgs.forEach(elm => {

					PROJECT.svg.animateSVGOnScrollGsap(elm);

				});

			},

			speakers: function() {

				const svgs = document.querySelectorAll('.jsSpeakersSvg');

				svgs.forEach(elm => {

					PROJECT.svg.animateSVGOnScrollGsap(elm);

				});

			},

			partners: function() {

				const svgs = document.querySelectorAll('.jsPartnersSvg');

				svgs.forEach(elm => {

					PROJECT.svg.animateSVGOnScrollGsap(elm);

				});

			},

			schedule: function() {

				const svgs = document.querySelectorAll('.jsScheduleSvg');

				svgs.forEach(elm => {

					PROJECT.svg.animateSVGOnScrollGsap(elm);

				});

			},

			listHeader: function() {

				const listHeaders = document.querySelectorAll('.jsListHeaderSvg');

				listHeaders.forEach(elm => {

					PROJECT.svg.animateSVGOnScrollGsap(elm);

				});

			},

			liveCarousel: function() {

				const liveCarousels = document.querySelectorAll('.jsLiveCarouselSvg');

				liveCarousels.forEach(elm => {

					PROJECT.svg.animateSVGOnScrollGsap(elm);

				});

			},

			animateSVGOnScrollGsap: function(container, options = {}) {

				const {
					duration = 0,
					staggerEach = 0.001,
					start = 'top 40%',
					ease = 'ease.inOut'
				} = options;

				const svg = container.querySelector('svg');
				if (!svg) return;

				const paths = Array.from(svg.querySelectorAll('path'));
				if (!paths.length) return;

				const animatedPaths = paths.slice(1);
				if (!animatedPaths.length) return;

				paths.forEach(path => {
					path.removeAttribute('style');
					path.style.display = 'none';
					path.style.opacity = '0';
					path.style.visibility = 'hidden';
					path.style.pointerEvents = 'none';
				});

				animatedPaths.forEach(path => {
					path.style.display = '';
				});

				gsap.set(paths, { autoAlpha: 0 });

				gsap.to(animatedPaths, {
					autoAlpha: 1,
					duration,
					ease,
					force3D: false,
					overwrite: 'auto',
					stagger: {
						each: staggerEach,
						from: 'start'
					},
					scrollTrigger: {
						trigger: container,
						start,
						toggleActions: 'play none none none',
						once: true
					}
				});

			},

			animateSVGDrawOnScrollGsap: function(container) {

				const svg = container.querySelector('svg');
				if (!svg) return;

				const paths = Array.from(svg.querySelectorAll('path'));
				if (!paths.length) return;
				const animatedPaths = paths.slice(1);
				if (!animatedPaths.length) return;

				paths.forEach(path => {
					path.removeAttribute('style');
					path.style.display = 'none';
					path.style.opacity = '0';
					path.style.visibility = 'hidden';
					path.style.pointerEvents = 'none';
				});

				animatedPaths.forEach(path => {
					path.style.display = '';
				});

				gsap.set(paths, { autoAlpha: 0 });

				const total = animatedPaths.length;
				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: container,
						start: 'top 80%',
						end: 'bottom 20%',
						scrub: 0.45,
						fastScrollEnd: true
					}
				});

				animatedPaths.forEach((path, i) => {
					const start = i / total;
					const dur = 1 / total;
					tl.to(path, { autoAlpha: 1, duration: dur, ease: 'none' }, start);
				});

			},

		},

		stackable: {

			init: function () {

				this.initStackingCards('.jsStackingCards', '.jsStackingCardsItem', {
					useScaleScrolling: true,
					disableStacking: true,
					useOpacityScrolling: true,
					breakPoint: '0px',
				});

				this.initBackgroundVideoPlayback();

			},

			initBackgroundVideoPlayback: function () {

				const section = document.querySelector('.jsStackableBlocks');
				if (!section) return;

				const video = section.querySelector('.jsStackableBackgroundVideo');
				if (!video) return;

				const onScroll = function () {
					if (section.getBoundingClientRect().top <= 0) {

						video.playbackRate = 0.5;
						video.play().catch(function () {});

						window.removeEventListener('scroll', onScroll);
					}
				};

				window.addEventListener('scroll', onScroll, { passive: true });
			},

			initStackingCards: function (containerSelector, itemSelector, options = {}) {
				function StackCards(container, itemSelector, options = {}) {
					this.element = container;
					this.items = container.querySelectorAll(itemSelector);
					this.itemSelector = itemSelector;
					this.useScaleScrolling = options.useScaleScrolling !== false; // default: true
					this.disableStacking = options.disableStacking === true;      // default: false
					this.useOpacityScrolling = options.useOpacityScrolling !== false;
					this.breakPoint = options.breakPoint ? options.breakPoint : '0px';      // default: false
					this.scrollingFn = null;
					this.scrolling = false;

					this.init();
				}

				StackCards.prototype.init = function () {
					this.setStackCards();
					this.initResizeObserver();
					this.initIntersectionObserver();
				};

				StackCards.prototype.setStackCards = function () {

					this.marginY = getComputedStyle(this.element).getPropertyValue('--stack-cards-gap');
					this.convertMarginToPx();
					this.elementHeight = this.element.offsetHeight;

					if (!this.items.length) return;

					const cardStyle = getComputedStyle(this.items[0]);
					this.cardTop = parseFloat(cardStyle.getPropertyValue('top')) || 0;
					this.cardHeight = parseFloat(cardStyle.getPropertyValue('height')) || 0;
					this.windowHeight = window.innerHeight;

					// Always apply bottom padding to create visual space
					this.element.style.paddingBottom = isNaN(this.marginY)
						? '0px'
						: (this.marginY * (this.items.length - 1)) + 'px';


					if( this.disableStacking ) {

						this.element.style.marginBottom = isNaN(this.marginY)
							? '0px'
							: (this.marginY * -(this.items.length)) + 'px';

					}

					// Always apply spacing offset
					for (let i = 0; i < this.items.length; i++) {
						if (this.disableStacking) {
							// Use margin for spacing instead of transform
							this.items[i].style.marginBottom = `${this.marginY}px`;
							this.items[i].style.transform = `scale(1)`;
							this.items[i].style.opacity = 1;
						} else {
							// Use transform for stacking effect
							const offsetY = this.marginY * i;
							this.items[i].style.marginBottom = `0px`;
							this.items[i].style.transform = `translateY(${offsetY}px) scale(1)`;
							this.items[i].style.opacity = 1;
						}
					}

				};

				StackCards.prototype.convertMarginToPx = function () {
					const testDiv = document.createElement('div');
					testDiv.style.cssText = `opacity:0;visibility:hidden;position:absolute;height:${this.marginY}`;
					this.element.appendChild(testDiv);
					this.marginY = parseInt(getComputedStyle(testDiv).getPropertyValue('height'));
					this.element.removeChild(testDiv);
				};

				StackCards.prototype.initIntersectionObserver = function () {

					const observer = new IntersectionObserver(entries => {
						if (entries[0].isIntersecting) {
							if (!this.scrollingFn) this.startScrollListener();
						} else {
							if (this.scrollingFn) {
								window.removeEventListener('scroll', this.scrollingFn);
								this.scrollingFn = null;
							}
						}
					}, { threshold: [0, 1] });

					observer.observe(this.element);

				};

				StackCards.prototype.startScrollListener = function () {

					this.scrollingFn = this.onScroll.bind(this);
					window.addEventListener('scroll', this.scrollingFn);
				};

				StackCards.prototype.onScroll = function () {
					if (this.scrolling) return;
					this.scrolling = true;
					window.requestAnimationFrame(this.animate.bind(this));
				};

				StackCards.prototype.animate = function () {

					if (isNaN(this.marginY)) {
						this.scrolling = false;
						return;
					}

					const top = this.element.getBoundingClientRect().top;
					const total = this.items.length;

					for (let i = 0; i < total; i++) {
						let scale = 1;

						var scrolling = this.cardTop - top - i * (this.cardHeight + this.marginY);

						if (this.useScaleScrolling && window.matchMedia('(min-width:' + this.breakPoint + '').matches) {

							if (scrolling > 0) {

								scale = i === this.items.length - 1 ? 1 : (this.cardHeight - scrolling * 0.050) / this.cardHeight;
							}

							if(total === (i + 1) ) {

								scale = 1

							}

						}

						let opacity = 1;

						if (this.useOpacityScrolling && i !== total - 1) {
							if (scrolling > 0) {
								let fadeDistance = this.cardHeight + this.marginY * 1; // adjust multiplier for slower fade
								let scrollProgress = Math.min(scrolling / fadeDistance, 1);
								opacity = 1 - scrollProgress * 0.5;

								if( opacity === 0.5 ) {

									opacity = 0;

								}

							}
						}

						if (this.disableStacking) {
							// No stacking: use margin to separate items
							this.items[i].style.marginBottom = `${this.marginY}px`;
							this.items[i].style.transform = `scale(${scale})`;
							this.items[i].style.opacity = opacity;
						} else {
							const offsetY = this.marginY * i;
							this.items[i].style.marginBottom = `0px`; // reset margin
							this.items[i].style.transform = `translateY(${offsetY}px) scale(${scale})`;
							this.items[i].style.opacity = opacity;
						}
					}

					this.scrolling = false;

				};


				StackCards.prototype.initResizeObserver = function () {
					this.element.addEventListener('resize-stack-cards', () => {
						if (window.matchMedia('(min-width:' + this.breakPoint + '').matches) {
							this.setStackCards();
						} else {
							this.reset();
						}
					});
				};

				StackCards.prototype.reset = function () {

					for (let i = 0; i < this.items.length; i++) {
						this.items[i].style.transform = 'none';
					}

				};

				// Initialize all containers
				const containers = document.querySelectorAll(containerSelector);
				const instances = [];

				if (
					'IntersectionObserver' in window &&
					'IntersectionObserverEntry' in window &&
					'intersectionRatio' in window.IntersectionObserverEntry.prototype
				) {
				containers.forEach(container => {
					const instance = new StackCards(container, itemSelector, options);
					instances.push(instance);
				});

				const resizeEvent = new CustomEvent('resize-stack-cards');
				let resizeTimer = null;

				window.addEventListener('resize', function () {
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(() => {
					instances.forEach(instance => {
						instance.element.dispatchEvent(resizeEvent);
					});
					}, 500);
				});
				}
			}

		},

		carousels: {

			init: function() {

				PROJECT.carousels.partners();
				PROJECT.carousels.speakersCarousel();
				PROJECT.carousels.carousel();
				PROJECT.carousels.highlightNews();
				PROJECT.carousels.imageCarousel();
				PROJECT.carousels.liveCarousel();

			},

			partners: function() {
				const carousels = document.querySelectorAll('.jsPartnersCarousel');

				carousels.forEach(el => {
					const carousel = el.querySelector('.splide');

					const options = {
						type: 'loop',

						autoWidth: true,

						perMove: 1,

						direction: 'ltr',

						clones: PROJECT.carousels.getCloneCount( carousel ),

						arrows: false,

						pagination: false,

						drag: false,

						autoScroll: {
							speed: 1,
							pauseOnHover: false,
							pauseOnFocus: false,
						},

					};

					let splide = new Splide( carousel, options ).mount( {AutoScroll} );

					carousel.splideInstance = splide;
				});
			},

			getCloneCount: function( carouselContainer ) {
				const carouselContainerWidth = carouselContainer.offsetWidth;
				const windowWidth = window.innerWidth;

				const slides = carouselContainer.querySelectorAll( '.splide__slide' );

				if ( !slides.length ) return 0;

				const totalSlidesWidth = Array.from( slides ).reduce( ( total, slide ) => {
					return total + slide.offsetWidth;
				}, 0 );

				const avgSlideWidth = totalSlidesWidth / slides.length;

				// If existing slides already cover window width + 2 extra slides, no clones needed
				if ( totalSlidesWidth >= windowWidth + ( avgSlideWidth * 2 ) ) return 5;

				const slidesFitInContainer = Math.floor( carouselContainerWidth / avgSlideWidth );
				const containerFitInWindow = Math.floor( windowWidth / carouselContainerWidth );

				return containerFitInWindow * slidesFitInContainer;
			},

			speakersCarousel: function() {

				const sections = document.querySelectorAll( '.jsSpeakersCarouselSection' );

				sections.forEach( function( section ) {

					const carouselWrapper = section.querySelector( '.jsSpeakersCarousel' );

					if ( !carouselWrapper ) {
						return;
					}

					const speakersSwiper = new Swiper( carouselWrapper, {

						slidesPerView: 1.25,

						spaceBetween: 16,

						breakpoints: {

							768: {

								slidesPerView: 2,

							},

							1024: {

								slidesPerView: 3,
								spaceBetween: 20,

							},

							1280: {

								slidesPerView: 3,
								spaceBetween: 30,

							}

						}

					});

				} );

			},

			carousel: function() {

				const sections = document.querySelectorAll( '.jsCarouselSection' );

				sections.forEach( function( carousel ) {

					const carouselWrapper = carousel.querySelector( '.jsCarousel' );
					const carouselPrevEl = carousel.querySelector( '.jsCarouselPrev' );
					const carouselNextEl = carousel.querySelector( '.jsCarouselNext' );

					if ( !carouselWrapper ) {
						return;
					}

					const carouselSwiper = new Swiper( carouselWrapper, {

						modules: [ Navigation ],

						slidesPerView: 1.25,

						spaceBetween: 16,

						navigation: {
							nextEl: carouselNextEl,
							prevEl: carouselPrevEl,
							lockClass: 'v-slider-navigation__button--locked',
							disabledClass: 'v-slider-navigation__button--disabled',
						},

						breakpoints: {

							768: {

								slidesPerView: 2,

							},

							1024: {

								slidesPerView: 3,
								spaceBetween: 20,

							},

							1280: {

								slidesPerView: 3,
								spaceBetween: 30,

							}

						}

					});

				} );

			},

			highlightNews: function() {

				const sections = document.querySelectorAll( '.jsHighlightNewsSection' );

				sections.forEach( function( carousel ) {

					const carouselWrapper = carousel.querySelector( '.jsHighlightNewsCarousel' );
					const carouselPrevEl = carousel.querySelector( '.jsCarouselPrev' );
					const carouselNextEl = carousel.querySelector( '.jsCarouselNext' );
					const carouselScrollbar = carousel.querySelector( '.jsHighlightNewsScrollbar' );

					if ( !carouselWrapper ) {
						return;
					}

					const carouselSwiper = new Swiper( carouselWrapper, {

						modules: [ Navigation, Scrollbar ],

						observeParents: true,
						watchOverflow: false,

						slidesPerView: 1.25,

						spaceBetween: 16,

						navigation: {
							nextEl: carouselNextEl,
							prevEl: carouselPrevEl,
							lockClass: 'v-slider-navigation__button--locked',
							disabledClass: 'v-slider-navigation__button--disabled',
						},

						breakpoints: {

							768: {

								slidesPerView: 2,
								spaceBetween: 20,
							},

						},

						scrollbar: {
							el: carouselScrollbar,
							draggable: true,
						},

					});

				} );

			},

			imageCarousel: function() {

				const sections = document.querySelectorAll( '.jsImageCarouselSection' );

				sections.forEach( function( carousel ) {

					const carouselWrapper = carousel.querySelector( '.jsImageCarousel' );
					const carouselPrevEl = carousel.querySelector( '.jsCarouselPrev' );
					const carouselNextEl = carousel.querySelector( '.jsCarouselNext' );
					const carouselScrollbar = carousel.querySelector( '.jsImageCarouselScrollbar' );

					if ( !carouselWrapper ) {
						return;
					}

					const carouselSwiper = new Swiper( carouselWrapper, {

						modules: [ Navigation, Scrollbar ],

						slidesPerView: 'auto',

						centeredSlides: true,

	 					loop: true,

						spaceBetween: 16,

						navigation: {
							nextEl: carouselNextEl,
							prevEl: carouselPrevEl,
							lockClass: 'v-slider-navigation__button--locked',
							disabledClass: 'v-slider-navigation__button--disabled',
						},

						scrollbar: {
							el: carouselScrollbar,
							draggable: true,
						},

						breakpoints: {

							768: {

								spaceBetween: 20,

							},


						}

					});

				} );
			},

			liveCarousel: function() {

				document.querySelectorAll('.jsLiveCarouselSection').forEach(function(carousel) {

					const carouselRoot = carousel.querySelector('.jsLiveCarousel');
					if (!carouselRoot) return;

					let splide = null;
					let activeSlide = null;
					let syncTimeout = null;

					const getVideo = function(slide) {
						return slide ? slide.querySelector('.v-card-live-event__video') : null;
					};

					const activateSlide = function(slide) {
						const video = getVideo(slide);
						if (!video) return;

						video.controls = true;
						video.muted = true;
						video.playsInline = true;

						if (video.readyState >= 2) {
							slide.classList.add('is-video-ready');
						} else {
							video.addEventListener('playing', function() {
								slide.classList.add('is-video-ready');
							}, { once: true });
						}

						video.play().catch(function() {});
					};

					const resetSlide = function(slide) {
						const video = getVideo(slide);
						if (!video) return;

						video.pause();
						video.controls = false;
						video.muted = true;

						setTimeout(function() {
							slide.classList.remove('is-video-ready');
							video.currentTime = 0;
						}, 150);
					};

					const syncActiveSlide = function() {
						const slideObject = splide.Components.Slides.getAt(splide.index);
						const newActiveSlide = slideObject ? slideObject.slide : null;

						if (!newActiveSlide || newActiveSlide === activeSlide) return;

						resetSlide(activeSlide);

						activeSlide = newActiveSlide;

						activateSlide(activeSlide);
					};

					splide = new Splide(carouselRoot, {
						type: 'loop',
						updateOnMove: true,
						perPage: 3,
						focus: 'center',
						perMove: 1,
						gap: '30px',
						pagination: false,
						speed: 600,
						arrows: false,
						breakpoints: {
							768: {
								gap: '15px',
								perPage: 1,
							},
						},
					});

					splide.on('mounted', syncActiveSlide);

					splide.on('move', function() {
						clearTimeout(syncTimeout);
					});

					splide.on('moved', function() {
						clearTimeout(syncTimeout);

						syncTimeout = setTimeout(syncActiveSlide, 80);
					});

					splide.mount();

					window.addEventListener('load', syncActiveSlide);

				});
			},

		},

		hero: {

			parent: '.jsHero',
			svgElm: '.jsHeroSVG',
			videoElm: '.jsHeroVideo',
			iconElm: '.jsHeroIcon',
			svgDuration: 1000,//is in ms

			init: function() {

				const hero  = document.querySelector('.jsHero');

				if (hero === null) return false;

				PROJECT.hero.start( hero );

				document.addEventListener('click', function(event) {
					const muteLabel = event.target.closest('.jsHeroVideoMute');
					if (muteLabel) {
					  PROJECT.hero.mute( event );
					}
				});


				document.addEventListener('click', function(event) {
					const wrapper = event.target.closest('.jsHeroVideoWrapper');

					if ( !wrapper ) return;

					if ( event.target.closest('.jsHeroVideoMute') ) return;

					const hero       = wrapper.closest('.jsHero');
					const isExpanded = hero.classList.contains('is-expanded');
					const videoEl    = hero.querySelector('video');
					const isMuted    = videoEl && videoEl.muted;

					if ( isExpanded || !isMuted ) {
						PROJECT.hero.mute( event );
					}

				});

			},

			start: function( container ) {

				let hero = container;

				PROJECT.hero.svg( hero );

				setTimeout(() => {

					PROJECT.hero.videoV2( hero );

				}, PROJECT.hero.svgDuration);

				setTimeout(() => {

					document.body.style.overflow = 'auto';

				}, PROJECT.hero.svgDuration);


			},

			svg: function( container ) {

				const svg  = container.querySelector(PROJECT.hero.svgElm);
				if (!svg) return;

				const paths  = svg.querySelectorAll('path');
				const animatedCount = Math.max(paths.length - 1, 1);
				const staggerEach = (PROJECT.hero.svgDuration / 1000) / animatedCount;

				PROJECT.svg.animateSVGOnScrollGsap(container, {
					staggerEach,
					start: 'top bottom',
				});

			},

			mute: function( e ) {

				const target = e.target;

				const parent = target.closest('.jsHero');

				const muteLabel  = parent.querySelector('.jsHeroVideoMute');
				const videoParent = parent.querySelector('.jsHeroVideoWrapper');
				const mouseText  = videoParent.hasAttribute('data-mouse-text');

				const video = parent.querySelector('video');

				const isMuted = video.muted ? true : false;

				if( isMuted ) {

					video.muted = false;

					if(mouseText) videoParent.setAttribute('data-mouse-text',tabs_globals.sound.off);
					PROJECT.mousefollow._updateText( tabs_globals.sound.off );
					muteLabel.textContent = tabs_globals.sound.off;

				}else {

					video.muted = true;

					if(mouseText) videoParent.setAttribute('data-mouse-text',tabs_globals.sound.on);
					PROJECT.mousefollow._updateText( tabs_globals.sound.on );
					muteLabel.textContent = tabs_globals.sound.on;

				}

			},

			videoV2: function( container ) {

				let videoWrapper = container.querySelector('.jsHeroVideoWrapper');
				let iconWrapper  = container.querySelector('.jsHeroIconWrapper');
				let icon         = container.querySelector('.jsHeroIcon');
				let videoInner   = container.querySelector('.jsHeroVideo');
				let video        = videoInner.querySelector('video');
				let foreground   = container.querySelector('.s-hero__foreground');
				const hasIcon = !!(iconWrapper && icon);

				videoWrapper.classList.add('animDone');
				video.play();

				let initialW = 0;
				let initialH = 0;
				let resizeTimer = null;
				let anchorBottom = 0;
				let anchorRight = 0;
				const iconBottomOffset = 100;

				function positionIconWrapper() {
					if (!hasIcon) return;

					const iconSize = icon.offsetWidth || 100;
					const rightWithHalfIconOffset = anchorRight - (iconSize * 0.5);

					iconWrapper.style.bottom = Math.round(anchorBottom) + "px";
					iconWrapper.style.right  = Math.round(rightWithHalfIconOffset) + "px";
					iconWrapper.style.left   = "auto";
				}

				function setIconBaseSize() {
					if (!hasIcon) return;

					const iconBaseSize = window.innerWidth >= 996 ? 150 : 100;
					const iconBaseFont = window.innerWidth >= 996 ? 35 : 25;

					icon.style.width = iconBaseSize + "px";
					icon.style.height = iconBaseSize + "px";
					icon.style.fontSize = iconBaseFont + "px";
				}

				function setIconScaledSize(t) {
					if (!hasIcon) return;

					const progress = Math.min(Math.max(t, 0), 1);
					const iconFullSize = window.innerWidth >= 996 ? 150 : 100;
					const iconFullFont = window.innerWidth >= 996 ? 35 : 25;
					const iconSize = lerp(iconFullSize * 0.66, iconFullSize, progress);

					icon.style.width = iconSize + "px";
					icon.style.height = iconSize + "px";
					icon.style.fontSize = (iconSize / iconFullSize * iconFullFont) + "px";
				}

				function updateIconAnchorFromInitialRect() {
					if (!hasIcon) return;

					const parentRect = foreground.getBoundingClientRect();

					const initialVideoLeft = (parentRect.width - initialW) / 2;
					const initialVideoTop = (parentRect.height - initialH) / 2;
					const initialVideoRight = initialVideoLeft + initialW;
					const initialVideoBottom = initialVideoTop + initialH;

					anchorBottom = (parentRect.height - initialVideoBottom) + iconBottomOffset;
					anchorRight = (parentRect.width - initialVideoRight);
				}

				function applyInitialLayout() {
					initialW = window.innerWidth  * 0.5;
					initialH = window.innerHeight * 0.5;
					videoInner.style.width  = initialW + "px";
					videoInner.style.height = initialH + "px";
					setIconBaseSize();
					updateIconAnchorFromInitialRect();
					positionIconWrapper();
				}

				applyInitialLayout();

				setTimeout(() => {
					applyInitialLayout();
					requestAnimationFrame(() => {
						iconWrapper.classList.add('icon-bounce-in');
					});
				}, 500);

				window.addEventListener("resize", () => {
					clearTimeout(resizeTimer);
					resizeTimer = setTimeout(() => {
						initialW = window.innerWidth  * 0.5;
						initialH = window.innerHeight * 0.5;
						setIconBaseSize();
						updateIconAnchorFromInitialRect();

						const t = Math.min(Math.max(currentT, 0), 1);
						const targetW = window.innerWidth  * 1.01;
						const targetH = window.innerHeight * 1.01;
						const scaledW = t >= 0.99 ? "101vw" : (lerp(initialW, targetW, t) + "px");
						const scaledH = t >= 0.99 ? "101vh" : (lerp(initialH, targetH, t) + "px");

						setIconScaledSize(t);
						videoInner.style.width  = scaledW;
						videoInner.style.height = scaledH;
						positionIconWrapper();
					}, 60);
				});

				function lerp(start, end, t) {
					return start + (end - start) * t;
				}

				const zoomDistanceVh = 1.0; // 1.0 = 100vh scroll to reach full-screen

				function getScrollProgress() {
					const rect            = container.getBoundingClientRect();
					const windowHeight    = window.innerHeight;
					const scrolled        = -rect.top;
					const end             = Math.max(windowHeight * zoomDistanceVh, 1);
					return Math.min(Math.max(scrolled / end, 0), 1);
				}

				let currentT    = 0;
				let wasExpanded = false;
				let snapped     = false;

				function tick() {

					currentT = getScrollProgress();

					const t = currentT;

					const targetW = window.innerWidth  * 1.01;
					const targetH = window.innerHeight * 1.01;

					if (currentT >= 0.99 && !snapped) {
						videoInner.style.width  = "101vw";
						videoInner.style.height = "101vh";
						snapped = true;
					} else if (currentT < 0.99) {
						snapped = false;
						videoInner.style.width  = lerp(initialW, targetW, t) + "px";
						videoInner.style.height = lerp(initialH, targetH, t) + "px";
					}

					setIconScaledSize(t);
					positionIconWrapper();

					if (currentT >= 0.99 && !wasExpanded) {

						container.classList.add("is-expanded");
						PROJECT.mousefollow._register( videoWrapper );

						if ( videoWrapper.matches(':hover') ) {
							PROJECT.mousefollow._updateText( videoWrapper.getAttribute('data-mouse-text') );
							PROJECT.mousefollow._addState();
						}

						wasExpanded = true;

					} else if (currentT < 0.99 && wasExpanded) {

						container.classList.remove("is-expanded");

						PROJECT.mousefollow._unRegister( videoWrapper );

						wasExpanded = false;

					}

					requestAnimationFrame(tick);
				}

				requestAnimationFrame(tick);

			}

		},

		mousefollow: {

			_x: 0,
			_y: 0,
			_root: null,
			_mouseElement: null,
			_mouseElementText: null,

			init: function () {

				PROJECT.mousefollow._root = document.documentElement;
				PROJECT.mousefollow._mouseElement = document.querySelector('#jsMouseFollowCursor');
				PROJECT.mousefollow._mouseElementText = PROJECT.mousefollow._mouseElement
					? PROJECT.mousefollow._mouseElement.querySelector('.jsMousePointerLabel')
					: null;

				document.documentElement.addEventListener('mousemove', PROJECT.mousefollow._onMouseMove);

				PROJECT.mousefollow._registerAll('.jsMouseFollow');


			},

			_onMouseMove: function (e) {

				if ( !PROJECT.mousefollow._root ) return;

				PROJECT.mousefollow._root.style.setProperty('--mouse-x', e.clientX + 'px');
				PROJECT.mousefollow._root.style.setProperty('--mouse-y', e.clientY + 'px');

			},

			_registerAll: function( selectors ) {

				const elements = document.querySelectorAll( selectors );

				if( !elements.length ) return false;

				elements.forEach(function(elm) {

					PROJECT.mousefollow._register( elm );

				});

			},

			_register: function( elm ) {

				elm._mouseFollowOver = PROJECT.mousefollow._hover;
				elm._mouseFollowOut = PROJECT.mousefollow._leave;

				elm.addEventListener('mouseover', PROJECT.mousefollow._hover);
				elm.addEventListener('mouseout', PROJECT.mousefollow._leave);

			},

			_unRegister: function( elm ) {

				elm.removeEventListener('mouseover', PROJECT.mousefollow._hover);
				elm.removeEventListener('mouseout', PROJECT.mousefollow._leave);

				PROJECT.mousefollow._leave();

			},

			_hover: function( event ) {

				const current = event.currentTarget;

				if(current.hasAttribute('data-mouse-text') ) {

					PROJECT.mousefollow._updateText( current.getAttribute('data-mouse-text') );

				}

				PROJECT.mousefollow._addState();

			},

			_leave: function() {

				PROJECT.mousefollow._removeState();
				PROJECT.mousefollow._updateText( '' );

			},

			_addState: function() {

				if ( !PROJECT.mousefollow._root ) return;

				PROJECT.mousefollow._root.classList.add('state-a-mousefollow--hover');

			},

			_removeState: function() {

				if ( !PROJECT.mousefollow._root ) return;

				PROJECT.mousefollow._root.classList.remove('state-a-mousefollow--hover');

			},

			_updateText: function( text ) {

				if ( !PROJECT.mousefollow._mouseElementText ) return;

				PROJECT.mousefollow._mouseElementText.innerHTML = text;

			}


		},

		videoEmbed: {

			selector: '.jsVideoEmbed',

			init: function() {

				var elms = document.querySelectorAll( PROJECT.videoEmbed.selector );

				if ( ! elms.length ) return;

				elms.forEach( PROJECT.videoEmbed.setup );

			},

			setup: function( el ) {

				var btn = el.querySelector( '.v-embed__play' );

				if ( ! btn ) return;

				var onActivate = function( e ) {

					e.preventDefault();
					PROJECT.videoEmbed.play( el );

				};

				btn.addEventListener( 'click', onActivate );
				btn.addEventListener( 'touchstart', onActivate, { passive: false } );

			},

			play: function( el ) {

				var embedUrl = el.getAttribute( 'data-embed-url' );

				if ( ! embedUrl ) return;

				var container = el.querySelector( '.v-embed__container' );

				if ( ! container ) return;

				var iframe = document.createElement( 'iframe' );

				iframe.src = embedUrl;
				iframe.setAttribute( 'frameborder', '0' );
				iframe.setAttribute( 'allowfullscreen', '' );
				iframe.setAttribute( 'allow', 'autoplay; fullscreen; picture-in-picture' );

				container.innerHTML = '';
				container.appendChild( iframe );

				el.classList.remove( 'v-embed--preview' );
				el.classList.add( 'v-embed--playing' );

			}

		},

		backgroundParallax: {

			init: function() {

				const texts = document.querySelectorAll('.jsParallax');

				if (!texts.length) return;

				// Skip parallax on touch devices — background-attachment: fixed
				// is broken on iOS/Android, and the JS simulation looks wrong there too.
				if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

				PROJECT.backgroundParallax.parallaxClipText(
					texts,
					'jsParallaxTarget'
				);

			},

			parallaxClipText: function(sections, className) {
				if (typeof sections === 'string') sections = document.querySelectorAll(sections);
				if (sections && sections.jquery) sections = sections.toArray();
				if (!sections || !sections.length) return;

				Array.from(sections).forEach(function(section) {
					var elements    = Array.from(section.querySelectorAll('.' + className));
					var active      = false;
					var resizeTimer = null;

					function setBgSize() {
						elements.forEach(function(el) {
							el.style.backgroundSize = '100vw 100vh';
						});
					}

					function update() {
						elements.forEach(function(el) {

							var rect = el.getBoundingClientRect();

							el.style.backgroundPositionY = -rect.top + 'px';
						});
					}

					setBgSize();
					update();

					new ResizeObserver(function() {
						clearTimeout(resizeTimer);
						resizeTimer = setTimeout(function() {
							setBgSize();
							if (active) update();
						}, 100);
					}).observe(section);

					new IntersectionObserver(function(entries) {
						active = entries[0].isIntersecting;
						if (active) update();
					}, { threshold: 0 }).observe(section);

					window.addEventListener('scroll', function() {
						if (active) update();
					}, { passive: true });
				});
			}

		},

		lightboxSpeaker: {

			isLoading: false,

			init: function() {

				$( document ).on( 'click', '.jsLightboxSpeakerTrigger', PROJECT.lightboxSpeaker.openTrigger );

				$( document ).on( 'click', '.jsLightboxSpeakerClose', PROJECT.lightboxSpeaker.close );

				$( document ).on( 'keydown', function( e ) {
					if ( e.key === 'Escape' && $( '.jsLightboxSpeakerElement' ).length ) {
						PROJECT.lightboxSpeaker.close( e );
					}
				} );

			},

			openTrigger: function( e ) {

				e.preventDefault();

				if ( PROJECT.lightboxSpeaker.isLoading ) return;

				const $trigger = $( this );

				const popupData = $trigger.data( 'popup-data' );

				PROJECT.lightboxSpeaker.open( popupData );

			},

			open: function( popupData ) {

				if ( !popupData ) return;

				PROJECT.lightboxSpeaker.isLoading = true;

				PROJECT.loader.show();

				$.ajax( {
					url: tabs_globals.ajaxurl,
					type: 'GET',
					data: {
						action: 'lightbox_speaker_load',
						popup_data: JSON.stringify( popupData ),
					},
					success: function( html ) {

						const $lightbox = $( $.parseHTML( html ) );
						$lightbox.hide();

						$( 'body' ).append( $lightbox );

						$( 'html' ).addClass( 'state-v-lightbox-speaker--lightbox-open' );

						$lightbox.css( 'display', 'flex' ).hide().fadeIn( 300, function() {

							PROJECT.loader.hide();

							const $overlay = $lightbox.find( '.jsLightboxSpeakerOverlay' );
							if ( $overlay.length ) {
								$overlay.addClass( 'is-active' );
							}
						} );

						const accordions = $lightbox.find('.jsAccordion');

						accordions.each((index, el) => {

							const accordion = new Accordion(el);
							el.accordionInstance = accordion;

						});

					},
					complete: function() {

						PROJECT.lightboxSpeaker.isLoading = false;

					}

				} );

			},

			close: function( e ) {

				e.preventDefault();

				$( '.jsLightboxSpeakerElement' ).fadeOut( 300, function() {

					$( this ).remove();

					$( 'html' ).removeClass( 'state-v-lightbox-speaker--lightbox-open' );

				} );

			}

		},

		lightboxPartner: {

			isLoading: false,

			partnerIds: [],

			currentIndex: 0,

			init: function() {

				$( document ).on( 'click', '.jsLightboxPartnerTrigger', PROJECT.lightboxPartner.openTrigger );

				$( document ).on( 'click', '.jsLightboxPartnerClose', PROJECT.lightboxPartner.close );

				$( document ).on( 'click', '.jsLightboxPartnerPrev', PROJECT.lightboxPartner.prev );
				$( document ).on( 'click', '.jsLightboxPartnerNext', PROJECT.lightboxPartner.next );

				$( document ).on( 'keydown', function( e ) {
					if ( e.key === 'Escape' && $( '.jsLightboxPartnerElement' ).length ) {
						PROJECT.lightboxPartner.close( e );
					}
				} );

			},

			openTrigger: function( e ) {

				e.preventDefault();

				if ( PROJECT.lightboxPartner.isLoading ) return;

				const $trigger = $( this );
				const popupData = $trigger.data( 'popup-data' );

				const $partnersList = $trigger.closest('.jsPartnersBlock').find('.jsPartnersBlockPartnersList');

				const partnerIds = $partnersList
					.find('.jsLightboxPartnerTrigger')
					.map(function () {
						const data = $(this).data('popup-data');
						return data && data.ID ? Number(data.ID) : null;
					})
					.get()
					.filter(Boolean);

				PROJECT.lightboxPartner.partnerIds = partnerIds;
				PROJECT.lightboxPartner.currentIndex = partnerIds.indexOf( popupData.ID );

				PROJECT.lightboxPartner.open( popupData );

			},

			open: function( popupData, replace = false ) {

				if ( !popupData ) return;

				PROJECT.lightboxPartner.isLoading = true;

				PROJECT.loader.show();

				$.ajax( {
					url: tabs_globals.ajaxurl,
					type: 'GET',
					data: {
						action: 'lightbox_partner_load',
						popup_data: JSON.stringify( popupData ),
					},
					success: function( html ) {

						const $lightbox = $( $.parseHTML( html ) );

						if (replace) {
							const $current = $('.jsLightboxPartnerElement');

							$lightbox.css('display', 'flex');

							$current.replaceWith($lightbox);

							PROJECT.lightboxPartner.updateNavButtonsState();

							const $overlay = $lightbox.find('.jsLightboxPartnerOverlay');
							if ($overlay.length) {
								$overlay.addClass('is-active');
							}

							PROJECT.loader.hide();
							return;
						}

						$lightbox.hide();

						$( 'body' ).append( $lightbox );

						$( 'html' ).addClass( 'state-v-lightbox-partner--lightbox-open' );

						$lightbox.css( 'display', 'flex' ).hide().fadeIn( 300, function() {

							PROJECT.loader.hide();

							const $overlay = $lightbox.find( '.jsLightboxPartnerOverlay' );
							if ( $overlay.length ) {
								$overlay.addClass( 'is-active' );
							}

							PROJECT.lightboxPartner.updateNavButtonsState();
						} );

					},
					complete: function() {

						PROJECT.lightboxPartner.isLoading = false;

					}

				} );

			},

			prev: function( e ) {

				e.preventDefault();

				PROJECT.lightboxPartner.goTo(-1);

			},

			next: function( e ) {

				e.preventDefault();

				PROJECT.lightboxPartner.goTo(1);

			},

			updateNavButtonsState: function() {

				const disabled = (PROJECT.lightboxPartner.partnerIds || []).length <= 1;

				$('.jsLightboxPartnerElement').find( '.jsLightboxPartnerPrev, .jsLightboxPartnerNext' )
					.prop( 'disabled', disabled )
					.attr( 'aria-disabled', disabled );

			},

			goTo: function( step ) {

				const ids = PROJECT.lightboxPartner.partnerIds;

				if( !ids.length ) return;
				if( PROJECT.lightboxPartner.isLoading ) return;

				let nextIndex = PROJECT.lightboxPartner.currentIndex + step;

				if( nextIndex < 0 ) {
					nextIndex = ids.length - 1;
				} else if( nextIndex >= ids.length ) {
					nextIndex = 0;
				}

				PROJECT.lightboxPartner.currentIndex = nextIndex;

				PROJECT.lightboxPartner.open( { ID: ids[nextIndex] }, true );

			},
			close: function( e ) {

				e.preventDefault();

				$( '.jsLightboxPartnerElement' ).fadeOut( 300, function() {

					$( this ).remove();

					$( 'html' ).removeClass( 'state-v-lightbox-partner--lightbox-open' );

				} );

			}

		},

		schedule: {

			init: function() {

				PROJECT.schedule.daysNavDrag();
				PROJECT.schedule.dateSessionToggle();
				PROJECT.schedule.filersNavDrag();
				PROJECT.schedule.sessionFilters();
				PROJECT.schedule.sessionsAccordions();

			},

			daysNavDrag: function() {

				const sliders = document.querySelectorAll('.jsNavScroll');
				sliders.forEach((el) => {

					const slider = new NavDrag(el, {

						dragThreshold: 10,

					 });

				});

			},

			dateSessionToggle: function() {

				const sections = document.querySelectorAll('.jsScheduleSection');

				sections.forEach(section => {

					const toggle = new ToggleSection(section,{
						triggersClass: '.jsScheduleDates',
						triggerClass: '.jsScheduleDate',
						targetsClass: '.jsScheduleSessions',
						targetClass: '.jsScheduleSession',
						dataAttr: 'data-schedule-date',
					})

					toggle.on('change', ({ event, trigger, triggerId, instance }) => {

						const parent = trigger.closest('.jsScheduleSection');

						if (!parent) return;

						// Reset filterNav
						(() => {

							const filterNav = parent.querySelector('.s-agenda__session.active .jsFilterNav');

							if (!filterNav) return;

							if (!filterNav.sliderInstance) return;

							filterNav.sliderInstance.reset();

						})(parent);

						// Reset filters
						(() => {

							const filters = parent.querySelectorAll('.jsSessionFilter');

							if (!filters) return;

							filters.forEach(el => {

								if( !el.filterInstance ) return false;

								el.filterInstance.reset();

							});

						})(parent);

						//Reset sectionAccordions
						(() => {

							const accordions = parent.querySelectorAll('.jsAccordion');

							if (!accordions) return;

							accordions.forEach(el => {

								if (!el.accordionInstance) return;

								el.accordionInstance.reset();

							});

						})(parent);

					});


				});

			},

			filersNavDrag: function() {

				const sliders = document.querySelectorAll('.jsFilterNav');
				sliders.forEach((el) => {

					const slider = new NavDrag(el, {

						dragThreshold: 10,

					 });

					 el.sliderInstance = slider;

				});

			},

			sessionFilters: function() {

				const filters = document.querySelectorAll('.jsSessionFilter');

				filters.forEach(el => {

					const filter = new HideFilter(el,{
						triggersClass: '.jsSessionFilterTriggers',
						triggerClass: '.jsSessionFilterTrigger',
						targetsClass: '.jsSessionFilterTargets',
						targetClass: '.jsSessionFilterTarget',
						dataAttr: 'data-filter',
						hideOthers: true,
					})

					el.filterInstance = filter;

				});


			},

			sessionsAccordions:function() {

				const accordions = document.querySelectorAll('.jsAccordion');

				accordions.forEach(el => {

					const accordion = new Accordion(el);
					el.accordionInstance = accordion;

				});

			}

		},

	};

	var UTIL = {

		exec: function (controller, action) {

			var ns = PROJECT;
			action = (action === undefined) ? 'init' : action;

			if (controller !== '' && ns[controller] && typeof ns[controller][action] === 'function') {

				ns[controller][action]();

			}

		},

		init: function () {

			var body = document.body,
				controller = body.getAttribute('data-controller'),
				action = body.getAttribute('data-action');

			UTIL.exec('common');
			UTIL.exec(controller);
			UTIL.exec(controller, action);

		}

	};

	//$.PROJECT = PROJECT; // Make global available

	$(window).ready(UTIL.init);

});

